import { render, staticRenderFns } from "./ResdpsRegister.vue?vue&type=template&id=2ede8569&scoped=true&"
import script from "./ResdpsRegister.vue?vue&type=script&lang=js&"
export * from "./ResdpsRegister.vue?vue&type=script&lang=js&"
import style0 from "./ResdpsRegister.vue?vue&type=style&index=0&id=2ede8569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ede8569",
  null
  
)

export default component.exports